import React from "react";
import { PacmanLoader } from "react-spinners";
import { Card, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { NumericFormat } from "react-number-format";
import { GetInvoiceHistoryForAllCustomers } from "../../actions/adminQueries";
import InvoiceItem from "../../components/Invoice/InvoiceItem";

export default function InvoiceHistory() {
  const invoiceHistory = GetInvoiceHistoryForAllCustomers();

  if (invoiceHistory.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  const result = invoiceHistory.data ?? [];

  if (result.length === 0) {
    return (
      <Row>
        <Col sm="6" md="10">
          <Card body>
            <FormattedMessage id="Views.Teacher.InvoiceHistory.NoInvoicesToShow" />
          </Card>
        </Col>
      </Row>
    );
  }

  const reducer = (accumulator, currentValue) => accumulator + currentValue;

  return (
    <div className="animated fadeIn">
      <Card body style={{ maxHeight: "250px" }}>
        <h4>
          <FormattedMessage id="OrderHistory" />
        </h4>
        <h6 className="text-muted mb-0">
          <FormattedMessage id="NumberOfOrders" /> {result.length}{" "}
          <FormattedMessage id="PiecesShort" />{" "}
          <FormattedMessage id="SumTotal" />{" "}
          <NumericFormat
            value={result.map((r) => r.price).reduce(reducer)}
            displayType={"text"}
            thousandSeparator={" "}
          />{" "}
          <FormattedMessage id="SEK" />
        </h6>
      </Card>
      <Card body>
        {result
          .sort((a, b) => new Date(b.created) - new Date(a.created))
          .map((invoice, i) => {
            return (
              <InvoiceItem key={i} invoice={invoice} fortNoxDisplay={true} />
            );
          })}
      </Card>
    </div>
  );
}
